export const TOTAL_STAGES = 6;

//Reducer Actions -
export const NEXT_STAGE = "NEXT_STAGE";
export const PREVIOUS_STAGE = "PREVIOUS_STAGE";
export const SUBMIT_FINAL = "SUBMIT_FINAL";
export const NEXT_BUTTON_UPDATE = "NEXT_BUTTON_UPDATE";
export const SAVE_AND_EXIT_UPDATE = "SAVE_AND_EXIT_UPDATE";
export const DETAILS_AVAILABLE_TO_PROCEED = "DETAILS_AVAILABLE_TO_PROCEED";

// Links
export const RESELLER_GUIDE =
  "http://partnerdownload.adobe.com/p/NA_Reseller_Program_Guide_UE.pdf";
// export const ADOBE_CHANNEL_PARTNER = 'https://channelpartners.stage.adobe.com/home.html';
export const CONTACT_HELPDESK = "http://www.adobe.com/support/reseller/";
export const RESELLER_PROG_TANDC =
  "http://partnerdownload.adobe.com/p/Americas_Reseller_Program_TandC_UE.pdf";
